import { Registry } from '@amzn/awscat-cookie-management';

const userSettings = 'userSettings';

export const ShortbreadRegistry: Registry = {
    state: { category: 'essential' },
    [userSettings]: { category: 'functional' },
};
